<template>
  <div class="map">
    <div id="container"></div>
  </div>
</template>

<script>
export default {
  name: 'Map',
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    window.onLoad  = function(){
        var map = new AMap.Map('container', {
            zoom:13,//级别
            center: [113.94453859452136, 22.549080010425282],//中心点坐标
            viewMode:'3D'//使用3D视图
        });

        var toolbar = new AMap.ToolBar();
        map.addControl(toolbar);

        var marker = new AMap.Marker({
            // content: "<div style='width:200px;font-size:12px;color:#000;font-weight:700'>深圳市前海尚云信息技术有限公司</div>",
            position: new AMap.LngLat(113.94453859452136, 22.549080010425282),
            // offset: new AMap.Pixel(-10, -10),
            // icon: '//vdata.amap.com/icons/b18/1/2.png', // 添加 Icon 图标 URL
            title: '深圳市前海尚云信息技术有限公司'
        });

        map.add(marker);
    }
    var key = '22d85116f31862cbb841d85ed1d87144'
    var url = `https://webapi.amap.com/maps?v=1.4.15&key=${ key }值&plugin=AMap.ToolBar&callback=onLoad`;
    var jsapi = document.createElement('script');
    jsapi.charset = 'utf-8';
    jsapi.src = url;
    document.head.appendChild(jsapi);

  }
}
</script>
<style scoped>
.map{display: flex;justify-content: center;align-items: center;padding: 20px 0 80px 0;margin: 0;}
#container{height: 500px;width: 70%;display: block;margin: 0;padding: 0;}
</style>


// WEBPACK FOOTER //
// src/components/map.vue